export default __webpack_public_path__ + "static/media/LogoImage-min.9e86f645.png";